import React, { Component } from 'react';
import { isEmpty } from '../../../Common/Common';
import { Colours } from '../../../Common/colours';

import Categories_Pie_Charts from '../../../Reports/Realtime/Charts/Categories_Pie_Charts';
import Total_Hourly_Bar_Chart from '../../../Reports/Realtime/Charts/Total_Hourly_Bar_Chart';
import Display_Cell_Label from './Display_Cell_Label';
import Display_Cell_Value from './Display_Cell_Value';
import Display_Cell_Unit from './Display_Cell_Unit';

export default class Target_Cell extends Component {
	constructor(props) {
		super(props);
		let x = 0;
		let y = 0;
		if (!isEmpty(this.props.target_info)) {
			x = this.props.target_info.x;
			y = this.props.target_info.y;
		}

		this.state = {
			x: x,
			y: y,
			showToolTip: false
		}

		// Original position of mouse when dragging starts
		this.mouse_start_x = 0;
		this.mouse_start_y = 0;

		// Original position of element before dragging
		this.orig_pos_x = x;
		this.orig_pos_y = y;

		// Whether this component is activated to move
		this.is_active = false;

		this.total_hourly_bar_chart = React.createRef();
		this.categories_pie_charts = React.createRef();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.data !== this.props.data) {
			this.total_hourly_bar_chart.current.refreshChart();
			this.categories_pie_charts.current.refreshChart();
		}
	}

	onMouseEnter = () => {
		this.setState({ showToolTip: true });
	}

	onMouseLeave = () => {
		this.setState({ showToolTip: false });
	}

	onDragStart = (event) => {
		event.preventDefault();
		if (this.props.is_movable) {
			if (event.clientX != null && !isNaN(event.clientX)) {
				this.mouse_start_x = event.clientX;
				this.mouse_start_y = event.clientY;
			} else {
				let touch = event.touches[0];
				this.mouse_start_x = touch.clientX;
				this.mouse_start_y = touch.clientY;
			}

			this.is_active = true;
			this.orig_pos_x = this.state.x;
			this.orig_pos_y = this.state.y;
		}
	}

	onDrag = (event) => {
		event.preventDefault();
		if (this.props.is_movable && this.is_active) {
			let mouse_end_x = 0;
			let mouse_end_y = 0;

			if (event.clientX != null && !isNaN(event.clientX)) {
				mouse_end_x = event.clientX;
				mouse_end_y = event.clientY;
			} else {
				let touch = event.touches[0];
				mouse_end_x = touch.clientX;
				mouse_end_y = touch.clientY;
			}

			// current position of target cell 
			let pos_x = this.orig_pos_x;
			let pos_y = this.orig_pos_y;

			let offset_x = mouse_end_x - this.mouse_start_x;
			let offset_y = mouse_end_y - this.mouse_start_y;

			// new position of target cell
			pos_x = pos_x + offset_x;
			pos_y = pos_y + offset_y;

			//if shiftKey pressed, snap to grid
			if (event.shiftKey) {
				pos_x = Math.round(pos_x / 10) * 10;
				pos_y = Math.round(pos_y / 10) * 10;
			}

			this.setState({ x: pos_x, y: pos_y });
		}
	}

	onDragEnd = (event) => {
		event.preventDefault();
		if (this.props.is_movable) {
			let mouse_end_x = 0;
			let mouse_end_y = 0;

			if (event.clientX != null && !isNaN(event.clientX)) {
				mouse_end_x = event.clientX;
				mouse_end_y = event.clientY;
			} else {
				let touch = event.touches[0];
				mouse_end_x = touch.clientX;
				mouse_end_y = touch.clientY;
			}

			// current position of target cell 
			let pos_x = this.orig_pos_x;
			let pos_y = this.orig_pos_y;

			let offset_x = mouse_end_x - this.mouse_start_x;
			let offset_y = mouse_end_y - this.mouse_start_y;

			// new position of target cell
			pos_x = pos_x + offset_x;
			pos_y = pos_y + offset_y;

			this.setState({ x: pos_x, y: pos_y });

			this.props.handleChangePosition(pos_x, pos_y, this.props.index);
		}
	}

	handleOnClick = () => {
		if (!this.props.is_movable) {
			//view screen. Now no need to do anything.
			/* switch(this.props.target_info.type){
				//case 'pieChart':
				
					//break;
				default:
					
			} */
		} else {
			this.props.handleSelectedCell(this.props.target_info.id, this.props.target_info.type);
		}
	}

	render() {
		/*
		 * Smallest cell
		 * Width: 75
		 * height: 50
		 * icon width: 25
		 * Additional info icon = 10
		 * fontSize 10
		 */
		let coefficient = 25; // controls the increment in size
		let cell_width = 50 + (coefficient * this.props.target_info.size);
		let cell_height = (cell_width / 3) * 2;
		let display_elem = null; // Display elem will be generated dynamically according to target type
		let backgroundColor = 'none';

		if (!isEmpty(this.props.target_info)) {
			switch (this.props.target_info.type) {
				case 'pieChart':
					//backgroundColor = Colours.light.realtime_bg;
					backgroundColor = 'white';
					display_elem =
						<Categories_Pie_Charts
							ref={this.categories_pie_charts}
							data={this.props.data}
							receiver={this.props.receiver}
							//height={cell_height * 5}
							//width={cell_width * 5}
							height={416}
							width={625}
							report_settings={this.props.report_settings}
						/>
					break;
				case 'barChart':
					//backgroundColor = Colours.light.realtime_bg;
					backgroundColor = 'white';
					display_elem =
						<Total_Hourly_Bar_Chart
							ref={this.total_hourly_bar_chart}
							data={this.props.data}
							receiver={this.props.receiver}
							//height={cell_height * 5}
							//width={cell_width * 5}
							height={416}
							width={625}
						/>
					break;
				case 'totalEnergyMonthLabel':
				case 'totalEnergyDayLabel':
				case 'energyGenMonthLabel':
				case 'energyGenDayLabel':
				case 'waterConsumeMonthLabel':
				case 'waterConsumeDayLabel':
				case 'energyCatMonthLabel':
				case 'energyCatDayLabel':
					backgroundColor = 'none';
					display_elem = <Display_Cell_Label
						target_info={this.props.target_info}
						data={this.props.data}
						receiver={this.props.receiver}
						report_settings={this.props.report_settings}
						size={this.props.target_info.size}
						cell_width={cell_width}
					/>
					break;
				case 'totalEnergyMonthValue':
				case 'totalEnergyDayValue':
				case 'energyGenMonthValue':
				case 'energyGenDayValue':
				case 'waterConsumeMonthValue':
				case 'waterConsumeDayValue':
				case 'energyCatMonthValue':
				case 'energyCatDayValue':
					backgroundColor = 'none';
					display_elem = <Display_Cell_Value
						target_info={this.props.target_info}
						data={this.props.data}
						receiver={this.props.receiver}
						size={this.props.target_info.size}
						cell_width={cell_width}
					/>
					break;
				case 'totalEnergyMonthUnit':
				case 'totalEnergyDayUnit':
				case 'energyGenMonthUnit':
				case 'energyGenDayUnit':
				case 'waterConsumeMonthUnit':
				case 'waterConsumeDayUnit':
				case 'energyCatMonthUnit':
				case 'energyCatDayUnit':
					backgroundColor = 'none';
					display_elem = <Display_Cell_Unit
						target_info={this.props.target_info}
						data={this.props.data}
						receiver={this.props.receiver}
						size={this.props.target_info.size}
						cell_width={cell_width}
					/>
					break;
				default:

			}
		}

		let scaleSize = {
			1: 1,
			2: 1.2,
			3: 1.4,
			4: 1.6,
			5: 1.8,
			6: 2,
			7: 2.2,
		}

		let cell_style = {
			cursor: this.props.is_movable ? 'pointer' : 'default',
			textAlign: 'center',
			position: 'absolute',
			top: this.state.y,
			left: this.state.x,
			zIndex: this.state.showToolTip ? '999999' : this.props.index,
			background: backgroundColor,
			whiteSpace: 'nowrap',
		}

		let toolTipStyle = {
			top: '50px',
			left: '50px',
			display: this.state.showToolTip ? 'block' : 'none',
			fontSize: '14px',
			position: 'absolute',
			color: 'black',
			backgroundColor: 'white',
			border: '1px solid navy',
			padding: '1px 2px',
			zIndex: '999999',
			whiteSpace: 'nowrap'
		}

		let targetCellName = '';

		switch (this.props.target_info.type) {
			case 'pieChart':
				targetCellName = this.props.receiver.getString('pie_chart');
				break;
			case 'barChart':
				targetCellName = this.props.receiver.getString('bar_chart');
				break;
			case 'totalEnergyMonthLabel':
				targetCellName = this.props.receiver.getString('total_energy_month') + ' : ' + this.props.receiver.getString('text_label');
				break;
			case 'totalEnergyMonthValue':
				targetCellName = this.props.receiver.getString('total_energy_month') + ' : ' + this.props.receiver.getString('value');
				break;
			case 'totalEnergyMonthUnit':
				targetCellName = this.props.receiver.getString('total_energy_month') + ' : ' + this.props.receiver.getString('unit');
				break;
			case 'totalEnergyDayLabel':
				targetCellName = this.props.receiver.getString('total_energy_day') + ' : ' + this.props.receiver.getString('text_label');
				break;
			case 'totalEnergyDayValue':
				targetCellName = this.props.receiver.getString('total_energy_day') + ' : ' + this.props.receiver.getString('value');
				break;
			case 'totalEnergyDayUnit':
				targetCellName = this.props.receiver.getString('total_energy_day') + ' : ' + this.props.receiver.getString('unit');
				break;
			case 'energyGenMonthLabel':
				targetCellName = this.props.receiver.getString('energy_generator_month') + ' : ' + this.props.receiver.getString('text_label');
				break;
			case 'energyGenMonthValue':
				targetCellName = this.props.receiver.getString('energy_generator_month') + ' : ' + this.props.receiver.getString('value');
				break;
			case 'energyGenMonthUnit':
				targetCellName = this.props.receiver.getString('energy_generator_month') + ' : ' + this.props.receiver.getString('unit');
				break;
			case 'energyGenDayLabel':
				targetCellName = this.props.receiver.getString('energy_generator_day') + ' : ' + this.props.receiver.getString('text_label');
				break;
			case 'energyGenDayValue':
				targetCellName = this.props.receiver.getString('energy_generator_day') + ' : ' + this.props.receiver.getString('value');
				break;
			case 'energyGenDayUnit':
				targetCellName = this.props.receiver.getString('energy_generator_day') + ' : ' + this.props.receiver.getString('unit');
				break;
			case 'waterConsumeMonthLabel':
				targetCellName = this.props.receiver.getString('water_consumption_month') + ' : ' + this.props.receiver.getString('text_label');
				break;
			case 'waterConsumeMonthValue':
				targetCellName = this.props.receiver.getString('water_consumption_month') + ' : ' + this.props.receiver.getString('value');
				break;
			case 'waterConsumeMonthUnit':
				targetCellName = this.props.receiver.getString('water_consumption_month') + ' : ' + this.props.receiver.getString('unit');
				break;
			case 'waterConsumeDayLabel':
				targetCellName = this.props.receiver.getString('water_consumption_day') + ' : ' + this.props.receiver.getString('text_label');
				break;
			case 'waterConsumeDayValue':
				targetCellName = this.props.receiver.getString('water_consumption_day') + ' : ' + this.props.receiver.getString('value');
				break;
			case 'waterConsumeDayUnit':
				targetCellName = this.props.receiver.getString('water_consumption_day') + ' : ' + this.props.receiver.getString('unit');
				break;
			case 'energyCatMonthLabel':
				if (this.props.report_settings.hasOwnProperty('categories')) {
					if (this.props.report_settings.categories.hasOwnProperty('energy')) {
						if (this.props.report_settings.categories.energy.hasOwnProperty(this.props.target_info.id)) {
							targetCellName = this.props.report_settings.categories.energy[this.props.target_info.id].name + ' ' + this.props.receiver.getString('by_month') + ' : ' + this.props.receiver.getString('text_label');
						}
					}
				}
				break;
			case 'energyCatMonthValue':
				if (this.props.report_settings.hasOwnProperty('categories')) {
					if (this.props.report_settings.categories.hasOwnProperty('energy')) {
						if (this.props.report_settings.categories.energy.hasOwnProperty(this.props.target_info.id)) {
							targetCellName = this.props.report_settings.categories.energy[this.props.target_info.id].name + ' ' + this.props.receiver.getString('by_month') + ' : ' + this.props.receiver.getString('value');
						}
					}
				}
				break;
			case 'energyCatMonthUnit':
				if (this.props.report_settings.hasOwnProperty('categories')) {
					if (this.props.report_settings.categories.hasOwnProperty('energy')) {
						if (this.props.report_settings.categories.energy.hasOwnProperty(this.props.target_info.id)) {
							targetCellName = this.props.report_settings.categories.energy[this.props.target_info.id].name + ' ' + this.props.receiver.getString('by_month') + ' : ' + this.props.receiver.getString('unit');
						}
					}
				}
				break;
			case 'energyCatDayLabel':
				if (this.props.report_settings.hasOwnProperty('categories')) {
					if (this.props.report_settings.categories.hasOwnProperty('energy')) {
						if (this.props.report_settings.categories.energy.hasOwnProperty(this.props.target_info.id)) {
							targetCellName = this.props.report_settings.categories.energy[this.props.target_info.id].name + ' ' + this.props.receiver.getString('by_day') + ' : ' + this.props.receiver.getString('text_label');
						}
					}
				}
				break;
			case 'energyCatDayValue':
				if (this.props.report_settings.hasOwnProperty('categories')) {
					if (this.props.report_settings.categories.hasOwnProperty('energy')) {
						if (this.props.report_settings.categories.energy.hasOwnProperty(this.props.target_info.id)) {
							targetCellName = this.props.report_settings.categories.energy[this.props.target_info.id].name + ' ' + this.props.receiver.getString('by_day') + ' : ' + this.props.receiver.getString('value');
						}
					}
				}
				break;
			case 'energyCatDayUnit':
				if (this.props.report_settings.hasOwnProperty('categories')) {
					if (this.props.report_settings.categories.hasOwnProperty('energy')) {
						if (this.props.report_settings.categories.energy.hasOwnProperty(this.props.target_info.id)) {
							targetCellName = this.props.report_settings.categories.energy[this.props.target_info.id].name + ' ' + this.props.receiver.getString('by_day') + ' : ' + this.props.receiver.getString('unit');
						}
					}
				}
				break;
			default:

		}

		return (
			<div
				id={'target_cell_' + this.props.index}
				style={cell_style}
				draggable
				onMouseDown={this.onDragStart}
				onMouseMove={this.onDrag}
				onMouseUp={this.onDragEnd}
				onMouseEnter={this.onMouseEnter}
				onMouseLeave={this.onMouseLeave}
				onTouchStart={this.onDragStart}
				onTouchMove={this.onDrag}
				onTouchEnd={this.onDragEnd}
				onClick={this.handleOnClick}
			>
				<div style={{ background: backgroundColor, transform: 'scale(' + scaleSize[this.props.target_info.size] + ')' }}> {display_elem} </div>
				<div style={toolTipStyle}> {targetCellName} </div>
			</div>
		)
	}
}